import React, { useState } from "react";
import { Button, Card, Col, Modal, Row, Form } from "react-bootstrap";
import {
  IconUserShield,
  IconUsersGroup,
  IconTruck,
  IconNote,
  IconUserShare,
  IconReportMoney,
  IconReportAnalytics,
  IconFilters,
} from "@tabler/icons-react";

function NotesDialog({
  isOpen,
  onClose,
  handleSectionSelect,
  fields,
  getValues,
}) {
  const [isCustomSection, setIsCustomSection] = useState(false);
  const [customSectionName, setCustomSectionName] = useState("");
  const [error, setError] = useState("");

  const handleSectionClick = (section) => {
    const existingSections = getValues("notes") || [];
    const sectionExists = existingSections.some(
      (sec) => sec.section === section
    );

    if (section === "other") {
      setIsCustomSection(true);
      setError("");
    } else if (!sectionExists) {
      handleSectionSelect(section);
      onClose();
    }
  };

  // const handleSectionClick = (section) => {
  //   const existingSections = getValues("notes");
  //   const sectionExists = existingSections.some(
  //     (sec) => sec.section === section
  //   );

  //   if (section === "other") {
  //     setIsCustomSection(true);
  //     setError("");
  //   } else if (!sectionExists) {
  //     handleSectionSelect(section);
  //     onClose();
  //   }
  // };

  const handleCustomSelect = () => {
    if (customSectionName.trim()) {
      const existingSections = getValues("notes");
      const sectionExists = existingSections.some(
        (sec) =>
          sec.section.toLowerCase() === customSectionName.trim().toLowerCase()
      );
      if (sectionExists) {
        setError(
          "This section already exists. Please choose a different name."
        );
      } else {
        handleSectionSelect(customSectionName.trim());
        onClose();
      }
    } else {
      setError("Section name cannot be empty.");
    }
  };

  return (
    <Modal centered show={isOpen} onHide={onClose}>
      <Modal.Header className="gap-2 align-items-center" closeButton>
        <span className="avatar bg-lime-lt rounded-circle">
          <IconUserShare />
        </span>
        <div>
          <Modal.Title>Notes</Modal.Title>
          <Card.Subtitle>You can add a section for your notes</Card.Subtitle>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Row>
          {[
            { name: "general", icon: <IconNote /> },
            { name: "sales", icon: <IconReportAnalytics /> },
            { name: "finance", icon: <IconReportMoney /> },
            { name: "logistics", icon: <IconTruck /> },
            { name: "customer", icon: <IconUsersGroup /> },
            { name: "vendor", icon: <IconUserShield /> },
            { name: "other", icon: <IconFilters /> },
          ].map((section) => (
            <Col md={6} className="mb-2" key={section.name}>
              <div
                className={`position-relative d-flex flex-column align-items-center justify-content-center radio-box ${
                  section.name === "other"
                    ? ""
                    : fields.some((field) => field.section === section.name)
                    ? "disabled active-radio-box"
                    : ""
                }`}
                onClick={() => handleSectionClick(section.name)}
                style={{
                  cursor:
                    section.name === "other"
                      ? "pointer"
                      : fields.some((field) => field.section === section.name)
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                {section.icon}
                <span>
                  {section.name.charAt(0).toUpperCase() + section.name.slice(1)}
                </span>
              </div>
            </Col>
          ))}
        </Row>

        {isCustomSection && (
          <Form.Group controlId="customSection" className="mt-3">
            <Form.Label>Enter Custom Section Name</Form.Label>
            <Form.Control
              type="text"
              value={customSectionName}
              onChange={(e) => {
                setCustomSectionName(e.target.value);
                setError(""); // Clear error on input change
              }}
              placeholder="Custom Section Name"
              isInvalid={!!error}
            />
            <Form.Control.Feedback type="invalid">
              {error}
            </Form.Control.Feedback>
          </Form.Group>
        )}
      </Modal.Body>

      <Modal.Footer>
        {!isCustomSection ? (
          <Button className="btn-warning" onClick={onClose}>
            Select
          </Button>
        ) : (
          <Button
            className="btn-warning"
            onClick={handleCustomSelect}
            disabled={!customSectionName.trim() || !!error}
          >
            Add Custom Section
          </Button>
        )}
        <Button onClick={onClose} variant="outline-secondary">
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default NotesDialog;
